import React from "react";
import { Navigate, useLocation } from "react-router-dom";

const ManageDefaultRoutes = ({ path }) => {
  const state = useLocation().state;

  return <Navigate to={path} state={state} />;
};
export default ManageDefaultRoutes;
